import { render, staticRenderFns } from "./BannerSidebarSendBanner.vue?vue&type=template&id=a74a9ed6"
import script from "./BannerSidebarSendBanner.vue?vue&type=script&lang=js"
export * from "./BannerSidebarSendBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports